import { Send } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { useForm } from "react-hook-form";

type FormValues = {
  message: string;
};

interface MessageInputProps {
  onSendMessage?: (message: string) => void;
}

const MessageInput = ({ onSendMessage }: MessageInputProps) => {
  const { register, handleSubmit, watch, reset } = useForm<FormValues>({
    defaultValues: {
      message: "",
    },
  });

  const message = watch("message");

  const onSubmit = ({ message }: FormValues) => {
    if (message === "") {
      return;
    }

    onSendMessage?.(message);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="outlined"
        fullWidth
        InputProps={{
          sx: { borderRadius: 100 },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton type="submit" disabled={message === ""}>
                <Send />
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...register("message")}
      />
    </form>
  );
};

export default MessageInput;
